import { render, staticRenderFns } from "./oldpeople.vue?vue&type=template&id=474a243f&scoped=true&"
import script from "./oldpeople.vue?vue&type=script&lang=js&"
export * from "./oldpeople.vue?vue&type=script&lang=js&"
import style0 from "./oldpeople.vue?vue&type=style&index=0&id=474a243f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a243f",
  null
  
)

export default component.exports